import React from 'react';
import { Col, Grid, Row } from 'antd';
import ImageC from 'src/components/Image';
import cn from "src/utils/cn";

type Props = {
	className?: string;
	title: string;
	point: string[];
	image: string[];
};

const InformationPoint = (props: Props) => {
	const { md, xl } = Grid.useBreakpoint();

	return (
		<div className={cn(props.className, 'bg-white')}>
			<Row className="container" align="middle">
				{!md && (
					<h2 className="mb-6 text-5xl font-bold max-xl:text-2xl max-xs:mt-6 max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
						{props.title}
					</h2>
				)}
				<Col xs={24} md={12}>
					<Row gutter={[16, 16]} justify="center">
						{props.image.map((item: string, index: number) => (
							<Col key={index}>
								<ImageC
									className="rounded-lg"
									width={xl ? 250 : md ? 150 : 125}
									height={xl ? 250 : md ? 150 : 125}
									src={`/images/stem-cell/${item}.png`}
								/>
							</Col>
						))}
					</Row>
				</Col>
				{!md && (
					<span className="text-2xl font-semibold max-xl:text-lg max-xs:text-sm max-xs:font-semibold max-xs:leading-7">
						Secretome di Indonesia memiliki banyak manfaat, seperti:
					</span>
				)}
				<Col className="md:mt-0 mt-2" xs={24} md={12}>
					{md && (
						<>
							<h2 className="mb-6 text-5xl font-bold max-xl:text-2xl max-xs:mt-6 max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
								{props.title}
							</h2>
							<span className="text-2xl font-semibold max-xl:text-lg max-xs:text-sm max-xs:font-semibold max-xs:leading-7">
								Secretome di Indonesia memiliki banyak manfaat, seperti:
							</span>
						</>
					)}
					{props.point.map((item: string, index: number) => (
						<Row className="xl:mb-2 mt-2" key={index} align="top">
							<Col className="flex md:pt-1" span={2}>
								<ImageC
									width={xl ? 24 : 18}
									height={xl ? 24 : 18}
									src="/images/stem-cell/icon-arrow-right.png"
								/>
							</Col>
							<Col span={22}>
								<p className="text-2xl font-bold max-xl:text-sm max-xs:leading-normal max-xs:font-normal max-xs:text-neutral-5">
									<span
										dangerouslySetInnerHTML={{
											__html: item,
										}}
									/>
								</p>
							</Col>
						</Row>
					))}
				</Col>
			</Row>
		</div>
	);
};

export default InformationPoint;
